import React, { useContext } from 'react';
import { Sentry } from '@opendoor/observability';
import { LOGIN_URL } from '../utils/constants';
import { CircularProgress, MessageBox, Button } from '@opendoor/mosaic';
import ErrorOutlineRoundedIcon from '@material-ui/icons/ErrorOutlineRounded';
import useWebSession from '../graphql/queries/web/useWebSession';
import { GetWebSession_web_userSession } from '../graphql/athena/types/GetWebSession';

export type SessionContextData = {
  session: GetWebSession_web_userSession;
};

export const SessionContext = React.createContext<SessionContextData>({
  session: { human: null },
});

export const useSessionContext = () => useContext(SessionContext);

export const SessionProvider: React.FC = ({ children }) => {
  const { data, loading, error, refetch } = useWebSession();
  const session: GetWebSession_web_userSession = data?.web?.userSession || {
    human: null,
  };

  const contextVal = {
    session,
  };

  if (loading) {
    return <CircularProgress className="mh-auto" size={72} thickness={5} />;
  }

  if (error) {
    return (
      <MessageBox
        image={<ErrorOutlineRoundedIcon className="h-5 w-5 mh-auto" />}
        description="Error fetching your user profile"
        extra={
          <Button className="mt-4" color="primary" onClick={() => refetch()}>
            Please try again
          </Button>
        }
      />
    );
  }

  if (!session.human) {
    window.location.assign(`${LOGIN_URL}?redirectTo=vendor/portal`);
    return null;
  }

  Sentry.configureScope((scope) => {
    scope.setUser({
      email: session.human?.email || undefined,
      token: session.human?.token || undefined,
    });
  });

  return <SessionContext.Provider value={contextVal}>{children}</SessionContext.Provider>;
};
